export const parsePriceQueryParam = (param: string): number => {
  return +parseFloat(param)?.toFixed(2)
};
